import { INTEGRATIONS } from '../../model/global-configuration.constant';
import { DefaultSettingsModel } from '../../valutrust-mapper-types/model/valuetrust.model';
import { DefaultSettingsModel as FNCDefaultSettingsModel } from '../../fnc-mapper-types/fnc-default-setting/model/fnc-default-setting.model';

export class SetProductListByIntegration {
	static readonly type = '[GlobalConfiguration] SetProductListByIntegration';

	constructor(public product: INTEGRATIONS) {}
}
export class SetNexsysAttributeList {
	static readonly type = '[GlobalConfiguration] SetNexsysAttributeList';
}

export class SetAcuityLenderBranches {
	static readonly type = '[GlobalConfiguration] SetAcuityLenderBranches';
}

export class SetCmpAcuityLenderBranches {
	static readonly type = '[GlobalConfiguration] SetCmpAcuityLenderBranches';
}


export class SetLenders {
	static readonly type = '[GlobalConfiguration] SetLenders';
}

export class SetAppScopePropertyTypes {
	static readonly type = '[GlobalConfiguration] SetAppScopePropertyTypes';
}

export class SetAppScopeLoanTypes {
	static readonly type = '[GlobalConfiguration] SetAppScopeLoanTypes';
}

export class SetAppScopeLoanReasons {
	static readonly type = '[GlobalConfiguration] SetAppScopeLoanReasons';
}

export class SetAcuityPropertyTypes {
	static readonly type = '[GlobalConfiguration] SetAcuityPropertyTypes';
}

export class SetAcuityLoanTypes {
	static readonly type = '[GlobalConfiguration] SetAcuityLoanTypes';
}

export class SetAcuityLoanReasons {
	static readonly type = '[GlobalConfiguration] SetAcuityLoanReasons';
}

export class SetAcuityOccupancyTypes {
	static readonly type = '[GlobalConfiguration] SetAcuityOccupancyTypes';
}

export class SetAppScopeOccupancyTypes {
	static readonly type = '[GlobalConfiguration] SetAppScopeOccupancyTypes';
}

export class SetNexsysMileStoneMessageStatus {
	static readonly type = '[GlobalConfiguration] SetMileStoneMessageStatus';
	constructor(public origin: INTEGRATIONS) {}
}

export class SetValutrustMileStoneMessageStatus {
	static readonly type = '[GlobalConfiguration] SetMileStoneMessageStatus';
	constructor(public origin: INTEGRATIONS) {}
}
export class SetAcuityDocumentTypes {
	static readonly type = '[GlobalConfiguration] SetAcuityDocumentTypes';
}

export class SetAppScopeDocumentTypes {
	static readonly type = '[GlobalConfiguration] SetAppScopeDocumentTypes';
}

export class SetClassValuationDocumentTypes {
	static readonly type = '[GlobalConfiguration] SetClassValuationDocumentTypes';
}

export class SetClassValuationDocTypes {
	static readonly type = '[GlobalConfiguration] SetClassValuationDocTypes';
}

export class SetFormTypes {
	static readonly type = '[GlobalConfiguration] SetFormTypes';
}

export class SetCIOrigins {
	static readonly type = '[GlobalConfiguration] SetCIOrigins';
}
export class SetCIOrganizations {
	static readonly type = '[GlobalConfiguration] SetCIOrganizations';
	constructor(public organizationName: string) {}
}
export class SetXpanseSettings {
	static readonly type = '[GlobalConfiguration] SetXpanseSettings';
	constructor(public defaultSettings: DefaultSettingsModel) {}
}

export class SetFNCSettings {
	static readonly type = '[GlobalConfiguration] SetFNCSettings';
	constructor(public defaultSettings: FNCDefaultSettingsModel) {}
}

export class SetGenericIntegrations {
	static readonly type = '[GlobalConfiguration] SetGenericIntegrations';
}

export class SetDeliveryAssetsAppScopeDocumentTypes {
	static readonly type = '[GlobalConfiguration] SetDeliveryAssetsAppScopeDocumentTypes';
}

export class SetDeliveryAssetsAcuityDocumentTypes {
	static readonly type = '[GlobalConfiguration] SetDeliveryAssetsAcuityDocumentTypes';
}

export class SetDeliveryAssetsClassValuationDocumentTypes {
	static readonly type = '[GlobalConfiguration] SetDeliveryAssetsClassValuationDocumentTypes';
}

export class SetDeliveryAssetsCmpAcuityDocumentTypes {
	static readonly type = '[GlobalConfiguration] SetDeliveryAssetsCmpAcuityDocumentTypes';
}

export class SetCmpAcuityPropertyTypes {
	static readonly type = '[GlobalConfiguration] SetCmpAcuityPropertyTypes';
}

export class SetCmpAcuityLoanTypes {
	static readonly type = '[GlobalConfiguration] SetCmpAcuityLoanTypes';
}

export class SetCmpAcuityLoanReasons {
	static readonly type = '[GlobalConfiguration] SetCmpAcuityLoanReasons';
}

export class SetCmpAcuityOccupancyTypes {
	static readonly type = '[GlobalConfiguration] SetCmpAcuityOccupancyTypes';
}

export class SetCmpAcuityDocumentTypes {
	static readonly type = '[GlobalConfiguration] SetCmpAcuityDocumentTypes';
}

export class SetAcuityMilestones {
	static readonly type = '[GlobalConfiguration] SetAcuityMilestones';
}

export class SetCmpAcuityMilestones {
	static readonly type = '[GlobalConfiguration] SetCmpAcuityMilestones';
}

export class SetAppScopeAssetOnCompletion {
	static readonly type = '[GlobalConfiguration] SetAppScopeAssetOnCompletion';
}

export class SetAcuityAssetOnCompletion {
	static readonly type = '[GlobalConfiguration] SetAcuityAssetOnCompletion';
}

export class SetSchemaList {
	static readonly type = '[GlobalConfiguration] SetSchemaList';
}
